var _defs, _rect, _text, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blikDot",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30A17"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 11.5,
    width: 44,
    height: 24,
    rx: 6,
    fill: "#101010",
    stroke: "#3d3d3d",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24.6,
    y: 30.4,
    textAnchor: "middle",
    fontFamily: "'Poppins','Century Gothic','Trebuchet MS',Arial,sans-serif",
    fontSize: 15.5,
    fontWeight: 700,
    letterSpacing: -0.6,
    fill: "#fff"
  }, "blik")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4,
    cy: 15.4,
    r: 2.7,
    fill: "url(#blikDot)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg108);
export default __webpack_public_path__ + "static/media/108.250681874c86e04000119cadb19b263e.svg";
export { ForwardRef as ReactComponent };